import makeRequest from 'api/makeRequest';
import environment from 'environment';

export const fetchQuickReplies = async (ticket, messages) => {
  const response = await makeRequest(environment.services.chatQuickRepliesMl, {
    method: 'post',
    data: { conversationId: ticket.ticketId, businessId: ticket.simplrAccountPtrId, messages },
  });

  const { toDisplay, quickRepliesRecommended, requestDetails } = response;

  return {
    hasQuickReplies: toDisplay,
    quickRepliesRecommended,
    quickRepliesAnalyticsData: {
      quickRepliesRecommended,
      requestDetails,
    },
    originalResponseData: response,
  };
};
